/** Interrupteur haut de page — données fictives, rien en base. */

type DemoToggleProps = {
  on: boolean;
  onChange: (on: boolean) => void;
};

export function DemoToggle({ on, onChange }: DemoToggleProps) {
  return (
    <button
      type="button"
      className={`fx-demo-toggle${on ? " is-on" : ""}`}
      aria-pressed={on}
      onClick={() => onChange(!on)}
    >
      <span className="fx-demo-toggle__dot" aria-hidden />
      Mode démo
    </button>
  );
}
